import { render, staticRenderFns } from "./France.vue?vue&type=template&id=2e7dd3c3&"
import script from "./France.vue?vue&type=script&lang=js&"
export * from "./France.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports